import CryptoJS from "crypto-js";

export const decrypt = (text) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(text, process.env.REACT_APP_CRYPTO_KEY).toString(
      CryptoJS.enc.Utf8
    )
  );
};

export const encrypt = (text = "") => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(text),
    process.env.REACT_APP_CRYPTO_KEY
  ).toString();
};
